import { Document, Packer, Paragraph, Table, TableRow, TableCell, WidthType, AlignmentType, BorderStyle, TextRun, ImageRun, VerticalAlign } from "docx";
import { saveAs } from "file-saver";
import { Button } from "reactstrap";

const PrintDocx = ({ data = null }) => {
  const product = data.cvlp_product?.name ?? "-";
  const productCategory = data.cvlp_product?.product_category?.name ?? "-";
  const productBlock = data.cvlp_product?.product_block?.name ?? "-";

  const fetchImage = async (url) => {
    const res = await fetch(url);
    return await res.arrayBuffer();
  };

  const chunkArray = (arr, size) => {
    const temp = [];
    for (let i = 0; i < arr.length; i += size) {
      temp.push(arr.slice(i, i + size));
    }
    return temp;
  };

  const getImageDimensions = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.src = url;
    });
  };

  const handleGenerate = async () => {
    const urls = data.cvlp_file.map((f) => {
      return `https://api-pkn.pkdeveloper.id/media/${f.filename}-w-200`;
    });

    const utilitas = ["- Instalasi Listrik : Tersedia", "- Penyambungan PLN : Tersedia", "- Sumur Pantek : Tersedia", "- Sumber Air : Tersedia", "- Septic Tank : Ada", "- Saluran Air Kotor : Tersedia", "- Tempat Cuci : Belum Ada", "- Bak Sampah : Ada", "- Plat Nomor Rumah : Ada", "- Tiang Bendera : Belum Ada", "- Pohon Peneduh : Belum Ada"];

    const maxWidthPerCell = 155; 

    const fotos = await Promise.all(
      urls.map(async (url) => {
        const buffer = await fetchImage(url);
        const { width, height } = await getImageDimensions(url);

        const ratio = height / width;
        const resizeHeight = Math.round(maxWidthPerCell * ratio);

        return {
          data: buffer,
          width: maxWidthPerCell,
          height: resizeHeight,
        };
      })
    );

    const chunks = chunkArray(fotos, 3);

    const noBorder = {
      top: { style: BorderStyle.NONE },
      bottom: { style: BorderStyle.NONE },
      left: { style: BorderStyle.NONE },
      right: { style: BorderStyle.NONE },
      insideHorizontal: { style: BorderStyle.NONE },
      insideVertical: { style: BorderStyle.NONE },
    };

    const tableRows = chunks.map((rowFotos) => {
      const cells = rowFotos.map((img) => {
        return new TableCell({
          width: { size: 33.33, type: WidthType.PERCENTAGE },
          margins: {
            top: 100,
            bottom: 100,
            left: 100,
            right: 100,
          },
          children: [
            new Paragraph({
              alignment: AlignmentType.CENTER,
              children: [
                new ImageRun({
                  data: img.data,
                  transformation: {
                    width: img.width,
                    height: img.height,
                  },
                }),
              ],
            }),
          ],
        });
      });

      while (cells.length < 3) {
        cells.push(
          new TableCell({
            width: { size: 33.33, type: WidthType.PERCENTAGE },
            children: [new Paragraph("")],
          })
        );
      }

      return new TableRow({ children: cells });
    });

    const half = Math.ceil(utilitas.length / 2);
    const leftCol = utilitas.slice(0, half);
    const rightCol = utilitas.slice(half);

    const tableRowsUtilitas = new TableRow({
      children: [
        new TableCell({
          width: { size: 50, type: WidthType.PERCENTAGE },
          borders: {
            top: { style: BorderStyle.SINGLE },
          },
          children: leftCol.map(
            (item) =>
              new Paragraph({
                alignment: AlignmentType.LEFT,
                spacing: { before: 50, after: 50 },
                children: [
                  new TextRun({
                    text: item,
                    bold: true,
                    italics: true,
                    size: 18,
                  }),
                ],
              })
          ),
        }),

        new TableCell({
          width: { size: 50, type: WidthType.PERCENTAGE },
          borders: {
            top: { style: BorderStyle.SINGLE },
          },
          children: rightCol.map(
            (item) =>
              new Paragraph({
                alignment: AlignmentType.LEFT,
                spacing: { before: 50, after: 50 },
                children: [
                  new TextRun({
                    text: item,
                    bold: true,
                    italics: true,
                    size: 18,
                  }),
                ],
              })
          ),
        }),
      ],
    });

    const tableRowsValid = [
      new TableRow({
        children: [
          new TableCell({
            borders: { top: { style: BorderStyle.SINGLE } },
            children: [
              new Paragraph({
                alignment: AlignmentType.CENTER,
                spacing: {
                  before: 100,
                  after: 100, 
                },
                children: [
                  new TextRun({
                    text: "DOKUMENTASI FOTO",
                    bold: true,
                  }),
                ],
              }),
            ],
          }),
        ],
      }),
      ...tableRows,
    ];

    const section1 = new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      rows: tableRowsValid,
    });

    const section2 = new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      rows: [
        new TableRow({
          children: [
            new TableCell({
              borders: { top: { style: BorderStyle.SINGLE } },
              children: [
                new Paragraph({
                  alignment: AlignmentType.CENTER,
                  spacing: {
                    before: 100, 
                    after: 100,
                  },
                  children: [
                    new TextRun({
                      text: `PERUMAHAN " ${data.cvlp_branch?.name ?? "-"} "`,
                      bold: true,
                    }),
                  ],
                }),
              ],
            }),
          ],
        }),
        new TableRow({
          children: [
            new TableCell({
              borders: { top: { style: BorderStyle.SINGLE } },
              children: [
                new Paragraph({
                  alignment: AlignmentType.CENTER,
                  spacing: {
                    before: 100, 
                    after: 100, 
                  },
                  children: [
                    new TextRun({
                      text: `${productCategory} - ${productBlock} - ${product}`,
                      size: 18,
                    }),
                  ],
                }),
              ],
            }),
          ],
        }),
        new TableRow({
          children: [
            new TableCell({
              borders: {
                top: { style: BorderStyle.SINGLE },
              },
              children: [
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  spacing: { before: 100, after: 100 },
                  children: [
                    new TextRun({
                      text: "UTILITAS DAN SARANA BANGUNAN",
                      bold: true,
                      italics: true,
                      size: 18,
                    }),
                  ],
                }),
              ],
            }),
          ],
        }),

        tableRowsUtilitas,
      ],
    });

    const doc = new Document({
      sections: [
        {
          children: [section1, section2],
        },
      ],
    });

    const blob = await Packer.toBlob(doc);
    saveAs(blob, "dokumen-ku.docx");
  };

  return (
    <Button color="light" className="btn-sm" onClick={handleGenerate}>
      <i className="ri-printer-line text-info fs-15"></i>
    </Button>
  );
};

export default PrintDocx;
